<!--
 * @Author: 王耀民
 * @Date: 2021/11/25 15:22
 * @Description: 记录收入、支出表单弹窗
-->
<template>
  <div>
    <el-button class="btn-record" @click="open()" :type="billType==1?'default':'primary'">记{{ typeText }}</el-button>

    <el-dialog :visible="visible"
               :title="'记'+typeText"
               :append-to-body="true"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :before-close="beforeClose"
               width="800px"
               custom-class='editindividualrecord'
    >

      <el-form :model="form" :rules="rules" label-width="110px" label-position="right" ref="formRef" class="form">

        <!-- 金额 -->
        <el-form-item
            class="input_amount"
            label="金额（元）："
            prop="billAmount"
            :rules="[{required: true, message: `请输入${typeText}金额`, trigger: 'blur'}]">
          <el-input
              v-model="form.billAmount"
              :placeholder="'请输入'+typeText+'金额'"
              v-input-limit="/^((\d{0,6})|(\d{1,6}\.(\d{1,2})?))$/"
          ></el-input>
        </el-form-item>

        <!-- 收入/支出类型 -->
        <el-form-item
            :label="typeText+'类型：'"
            prop="billCostType"
            :rules="[{required: true, message: `请选择${typeText}类型`, trigger: 'change'}]">
          <el-radio-group v-model="form.billCostType">
            <el-radio-button
                v-for="(item,index) in radioList"
                :key="index"
                :label="index+1"
            >
              {{ item }}
            </el-radio-button>
          </el-radio-group>
        </el-form-item>

        <!-- 日期 -->
        <el-form-item label="日期：" prop="billDate">
          <el-input :value="form.billDate" @focus="$refs.selectCalendar.open()"></el-input>
        </el-form-item>

        <!-- 备注 -->
        <el-form-item label="备注：" style="margin-bottom:0">
          <el-input
              class="input-remark"
              show-word-limit
              resize="none"
              type="textarea"
              placeholder="请填写备注"
              :maxlength="30"
              v-model="form.remark"
              @keydown.native.enter.prevent
          ></el-input>
        </el-form-item>
      </el-form>

      <!-- 底部按钮 -->
      <div slot="footer" class="flex_jc_center">
        <el-button @click="beforeClose">取消</el-button>
        <el-button @click="save" type="primary" style="margin-left:20px">保存</el-button>
      </div>
    </el-dialog>

    <!-- 选择日历弹窗组件 -->
    <SelectCalendar ref="selectCalendar" :redio="true" :value.sync="form.billDate"/>
  </div>
</template>

<script>
import {api} from '@/api/apiIndividualRecord'
import moment from 'moment'

export default {
  name: "AddIncomeExpenses",
  components: {
    SelectCalendar: () => import('@/views/record/components/statistics/statisticsBtn/components/selectCalendar.vue') // 选择日历弹窗组件
  },
  props: {
    /**
     * 记账类型,1:收入  2:支出
     */
    billType: {
      type: [Number, String],
      default: 1
    }
  },
  data() {
    return {
      visible: false,
      form: {
        billAmount: '', // 金额
        billCostType: '', // 消费类型
        billDate: '', // 日期（单选）
        remark: '' // 备注
      },
      radioList: [], // 收入支出类型
      incomeType: ['工资', '工程款', '奖金', '补贴', '其他'], // 类型为收入时的单选类型
      expensesType: ['工资发放', '材料费', '生活用品', '交通', '医疗', '吃饭', '娱乐', '住宿', '其他'], // 类型为支出时的单选类型
      rules: {
        billDate: [{required: true, message: '请选择日期', trigger: 'blur'}]
      },
      recordType: '', // 类型： 1 个人  2 班组
      loading: false
    }
  },
  methods: {
    /**
     * 打开记账弹窗
     * @param no {String} 要编辑的记账的no
     */
    open(no) {
      if (this.billType == 1) { // 收入
        this.radioList = this.incomeType
      } else if (this.billType == 2) { // 支出
        this.radioList = this.expensesType
      }
      this.recordType = this.$route.query.type ? this.$route.query.type : '1'
      this.form = {
        billAmount: '',
        billCostType: '',
        billDate: this.getToDay(),
        remark: ''
      }
      if (no) { // 编辑
        this.getDetail(no)
      }
      this.$nextTick(() => {
        this.$refs.formRef.clearValidate()
      })
      this.visible = true
    },
    /**
     * 获取当天日期
     * @returns {string} 当天日期（个位日期用0补位） 格式：YYYY-MM-DD
     */
    getToDay() {
      return moment(new Date()).format('YYYY-MM-DD')
    },
    /**
     * 关闭记账弹窗
     */
    beforeClose() {
      this.visible = false
      this.form = {
        billAmount: '',
        billCostType: '',
        billDate: this.getToDay(),
        remark: ''
      }
      this.$refs.formRef.clearValidate()
    },
    /**
     * 保存记账
     */
    save() {
      if (this.loading) return
      this.loading = true
      this.$refs.formRef.validate(async valid => {
        if (valid) {
          const params = {...this.form}
          params.billCostName = this.radioList[params.billCostType - 1] // 获取消费类型的文字
          params.type = this.recordType // 个人记账/班组记账
          params.billType = this.billType // 收入/支出
          const res = await api.settleBillAdd(params)
          if (res.data.code === 200) {
            this.beforeClose()
            this.$message.success('保存成功')
            this.$emit('close')
          } else {
            this.$message.error('系统异常，请稍后再试')
          }
        }
        this.loading = false
      })
    },
    /**
     * 根据记账no获取记账详情
     * @param no 记账no
     */
    async getDetail(no) {
      const res = await api.settleBillDetail(no)
      if (res.data.code === 200) {
        res.data.data.billDate = moment(res.data.data.billDate).format('YYYY-MM-DD') // 时间戳格式化为 YYYY-MM-DD
        this.form = res.data.data
      } else {
        this.$message.error('系统异常，请稍后再试')
      }
    }
  },
  computed: {
    /**
     * 记账类型的文字，用于表单显示
     * @returns {string} '收入' 或 '支出'
     */
    typeText() {
      return this.billType == 1 ? '收入' : '支出'
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog {
  .el-dialog__body {
    padding: 17px 140px 0 80px !important;
  }

  .el-dialog__footer {
    padding: 50px 0 40px;
  }
}

.form {
  font-size: 14px;

  .el-form-item {
    margin-bottom: 17px;
  }

  .el-input {
    width: 450px;
    height: 34px;
  }

  /deep/ .el-form-item__label {
    color: #000000;
  }

  /deep/ .el-input__inner {
    height: 34px;
    color: #666666;
  }

  /deep/ .el-radio-button {
    margin: 10px 20px 0 0;
  }

  /deep/ .el-radio-button__inner {
    padding: 9px 14px;
    border-radius: 4px !important;
    border: 1px solid #E4E7ED;
    color: #666666;
  }

  /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    color: #0286DF;
    background-color: #fff;
    border-color: #0286DF;
    box-shadow: none;
  }

  .input-remark {
    width: 450px;
    height: 68px;

    /deep/ .el-textarea__inner {
      height: 68px;
      padding: 8px 15px;
    }

    /deep/ .el-input__count {
      background: none;
      bottom: -3px;
      right: 17px;
      color: #C0C4CC;
      font-size: 14px;
    }
  }

  .input_amount {
    margin-bottom: 7px;

    /deep/ .el-form-item__content {
      height: 37px;
    }
  }
}


.el-button.btn-record {
  font-size: 14px;
  padding: 8px 15px;
  border-radius: 0;
  border: 1px solid #B79255;

  &.el-button--default {
    color: #B79255;

    &:hover, &:focus {
      color: #B79255 !important;
      background: #fff;
      border-color: #B79255 !important;
    }
  }

  &.el-button--primary {
    color: #FFFFFF;
    background: #B79255;
  }
}
</style>

